import { Color, RadiusScale, withCitrusTheme } from '@gousto-internal/citrus-react';

export const CARD_RADIUS = 4 as RadiusScale;

const RECIPE_BUTTON_RADIUS_PX = 8;

export const PersonOptionButton = withCitrusTheme('button', (theme) => ({
  appearance: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flex: '1 1 0%',
  minWidth: 0,
  padding: theme.spacing(4),
  textAlign: 'left',
  borderStyle: 'solid',
  borderWidth: '2px',
  borderColor: theme.color(Color.ColdGrey_100),
  backgroundColor: theme.color(Color.White),
  color: theme.color(Color.ColdGrey_800),
  ...theme.radius(CARD_RADIUS),
  '&:hover': {
    borderColor: theme.color(Color.ColdGrey_400),
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.color(Color.Secondary_600)}`,
    outlineOffset: '2px',
  },
  '&[data-selected="true"]': {
    backgroundColor: theme.color(Color.Secondary_400),
    color: theme.color(Color.White),
    borderColor: theme.color(Color.Secondary_400),
  },
  '&[data-selected="true"]:hover': {
    borderColor: theme.color(Color.Secondary_600),
    backgroundColor: theme.color(Color.Secondary_600),
  },
}));

export const RecipeOptionButton = withCitrusTheme('button', (theme) => ({
  appearance: 'none',
  cursor: 'pointer',
  fontFamily: 'inherit',
  minWidth: '51px',
  minHeight: '44px',
  padding: '10px 20px',
  position: 'relative',
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: theme.color(Color.ColdGrey_100),
  backgroundColor: theme.color(Color.White),
  color: theme.color(Color.ColdGrey_800),
  borderRadius: 0,
  marginLeft: '-1px',
  '&:first-of-type': {
    marginLeft: 0,
    borderTopLeftRadius: `${RECIPE_BUTTON_RADIUS_PX}px`,
    borderBottomLeftRadius: `${RECIPE_BUTTON_RADIUS_PX}px`,
  },
  '&:last-of-type': {
    borderTopRightRadius: `${RECIPE_BUTTON_RADIUS_PX}px`,
    borderBottomRightRadius: `${RECIPE_BUTTON_RADIUS_PX}px`,
  },
  '&:hover': {
    borderColor: theme.color(Color.ColdGrey_400),
    zIndex: 1,
  },
  '&:focus-visible': {
    outline: `2px solid ${theme.color(Color.Secondary_600)}`,
    outlineOffset: '2px',
    zIndex: 2,
  },
  '&[data-selected="true"]': {
    backgroundColor: theme.color(Color.Secondary_400),
    color: theme.color(Color.White),
    borderColor: theme.color(Color.Secondary_400),
    zIndex: 1,
  },
  '&[data-selected="true"]:hover': {
    borderColor: theme.color(Color.Secondary_600),
    backgroundColor: theme.color(Color.Secondary_600),
  },
}));

export const PriceBlockColumn = withCitrusTheme('div', (theme) => ({
  flex: '1 1 0%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(2),
}));
